<template>
  <div class="ch-filter-in-detail">
    <doorlock-logs-filter class="ma-0 mb-3"></doorlock-logs-filter>
    <doorlock-logs-list></doorlock-logs-list>
  </div>
</template>

<script>
  import DoorlockLogsFilter from '@/components/admin/doorlocks/DoorlockLogsFilter';
  import DoorlockLogsList from '@/components/admin/doorlocks/DoorlockLogsList';

  export default {
    components: {
      DoorlockLogsFilter, DoorlockLogsList,
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlocksLogs.vue